import breakpoints from '../../config/breakpoints.json';

// Removing units
const bp = {}
Object.keys(breakpoints[0]).map(key => bp[key] = parseInt(breakpoints[0][key].replace('px', '')));

const mq = {}
Object.keys(breakpoints[0]).map(key => {
    mq[key + 'Max'] = window.matchMedia('(max-width: '+ breakpoints[0][key] +')')
    mq[key] = window.matchMedia('(min-width: '+ breakpoints[0][key] +')')
});

/* const actions = {}; */
const atQuery = function(type, breakpoint, callback) {
    const query = type === 'max' ? mq[breakpoint + 'Max'] : mq[breakpoint];

    const cb = function(e) {
        if (e.matches) {
          callback();
        }
    }

    query.addListener(cb);
    cb(query);

    // ToDo: Cache breakpoints!
    /* if(actions[query]) {
        actions[query].push(cb);
    } else {
        actions[query] = [];
        actions[query].push(cb);
    } */
}

export {
    bp as breakpoints,
    mq as mediaQuery,
    atQuery
}


